// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlertPopup_alert__KHjey {
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 12px 20px;
    border-radius: 50px;
    font-size: 16px;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-width: 280px;
    max-width: 400px;
    color: white;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    opacity: 1;
    transform: translateY(0);
  }
  
  .AlertPopup_success__2mWyC {
    background-color: #b8ffc8;
    color: #28a745;
  }
  
  .AlertPopup_error__6wHXZ {
    background-color: #ff9da7;
    color: #dc3545;
  }
  
  .AlertPopup_warning__ZNZXY {
    background-color: #ffdf80;
    color: #212529;
  }
  
  .AlertPopup_info__26YsS {
    background-color: #9ef2ff;
    color: #17a2b8;
  }
  
  .AlertPopup_message__ticTC {
    flex: 1 1;
  }
  
  .AlertPopup_closeBtn__NiU3Z {
    background-color: rgba(255, 255, 255, 0.3);
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: inherit;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    transition: background-color 0.2s ease;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }
  .AlertPopup_closeBtn__NiU3Z:hover {
    background-color: rgba(255, 255, 255, 0.5); /* on hover */
  }
  /* Animation classes */
  .AlertPopup_fadeIn__0coMI {
    animation: AlertPopup_fadeIn__0coMI 0.4s ease-out forwards;
    transform: translate(-50%, 0);
  }
  
  .AlertPopup_fadeOut__saQbG {
    animation: AlertPopup_fadeOut__saQbG 0.5s ease-in forwards;
    transform: translate(-50%, -50px);
  }
  
  
  @keyframes AlertPopup_fadeIn__0coMI {
    from {
      opacity: 0;
      transform: translate(-50%, -50px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }
  
  @keyframes AlertPopup_fadeOut__saQbG {
    from {
      opacity: 1;
      transform: translate(-50%, 0);
    }
    to {
      opacity: 0;
      transform: translate(-50%, -50px);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Component/AlertPopup.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,0CAA0C;IAC1C,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,sCAAsC;IACtC,iDAAiD;EACnD;EACA;IACE,0CAA0C,EAAE,aAAa;EAC3D;EACA,sBAAsB;EACtB;IACE,0DAAwC;IACxC,6BAA6B;EAC/B;;EAEA;IACE,0DAAwC;IACxC,iCAAiC;EACnC;;;EAGA;IACE;MACE,UAAU;MACV,iCAAiC;IACnC;IACA;MACE,UAAU;MACV,6BAA6B;IAC/B;EACF;;EAEA;IACE;MACE,UAAU;MACV,6BAA6B;IAC/B;IACA;MACE,UAAU;MACV,iCAAiC;IACnC;EACF","sourcesContent":[".alert {\n    position: fixed;\n    top: 80px;\n    left: 50%;\n    transform: translate(-50%, 0);\n    padding: 12px 20px;\n    border-radius: 50px;\n    font-size: 16px;\n    z-index: 9999;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    min-width: 280px;\n    max-width: 400px;\n    color: white;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n    opacity: 1;\n    transform: translateY(0);\n  }\n  \n  .success {\n    background-color: #b8ffc8;\n    color: #28a745;\n  }\n  \n  .error {\n    background-color: #ff9da7;\n    color: #dc3545;\n  }\n  \n  .warning {\n    background-color: #ffdf80;\n    color: #212529;\n  }\n  \n  .info {\n    background-color: #9ef2ff;\n    color: #17a2b8;\n  }\n  \n  .message {\n    flex: 1;\n  }\n  \n  .closeBtn {\n    background-color: rgba(255, 255, 255, 0.3);\n    border: none;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    color: inherit;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 10px;\n    transition: background-color 0.2s ease;\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  }\n  .closeBtn:hover {\n    background-color: rgba(255, 255, 255, 0.5); /* on hover */\n  }\n  /* Animation classes */\n  .fadeIn {\n    animation: fadeIn 0.4s ease-out forwards;\n    transform: translate(-50%, 0);\n  }\n  \n  .fadeOut {\n    animation: fadeOut 0.5s ease-in forwards;\n    transform: translate(-50%, -50px);\n  }\n  \n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translate(-50%, -50px);\n    }\n    to {\n      opacity: 1;\n      transform: translate(-50%, 0);\n    }\n  }\n  \n  @keyframes fadeOut {\n    from {\n      opacity: 1;\n      transform: translate(-50%, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate(-50%, -50px);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `AlertPopup_alert__KHjey`,
	"success": `AlertPopup_success__2mWyC`,
	"error": `AlertPopup_error__6wHXZ`,
	"warning": `AlertPopup_warning__ZNZXY`,
	"info": `AlertPopup_info__26YsS`,
	"message": `AlertPopup_message__ticTC`,
	"closeBtn": `AlertPopup_closeBtn__NiU3Z`,
	"fadeIn": `AlertPopup_fadeIn__0coMI`,
	"fadeOut": `AlertPopup_fadeOut__saQbG`
};
export default ___CSS_LOADER_EXPORT___;
